/* eslint-disable import/no-default-export, @typescript-eslint/no-explicit-any */
import Backbone from 'app/scripts/vendor/backbone';

export default (Backbone as any);
